import posthog from 'posthog-js';
import { track } from '@vercel/analytics';
import { getEnvironmentData } from '../utils/environment';
import { analyticsOptOut } from '../utils/privacy';

export const trackGenerateSharePost = (platform, language, requestId = null) => {
  if (analyticsOptOut.hasOptedOut()) return;
  
  const eventData = {
    platform: platform,
    language: language,
    request_id: requestId,
    ...getEnvironmentData()
  };

  posthog.capture('generate_share_post', eventData);
  track('generate_share_post', eventData);
  
  // Add TikTok tracking
  if (typeof window !== 'undefined' && window.ttq) {
    window.ttq.track('ClickButton', {
      content_name: 'share_post_generator',
      content_type: 'product',
      content_id: requestId || 'share_generator'
    });
  }
}; 